import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Modal,
  Container,
  Table
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import InjectedCreditCardDetails from "components/CreditCardForm/CreditCardDetails.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import avatar from "assets/img/faces/face-3.jpg";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import InjectedCheckoutForm from 'components/CheckoutForms/CheckoutForm.jsx';
import {Elements} from 'react-stripe-elements';

const USE_PADDLE_FOR_FLOWPAPER_SERVICES = true;
const USE_PADDLE_FOR_ADDITIONAL_DOMAIN = true;
const USE_PADDLE_FOR_CREATIVE_UPGRADE = true;

function RenewFlowPaperServicesModal(props) {
  if(props.authDetail.detail.usePaddle||USE_PADDLE_FOR_FLOWPAPER_SERVICES){
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-700w">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Renew Your FlowPaper Services Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="content paymentForm" style={{paddingTop:0}}>
            <Elements>
              <InjectedCheckoutForm usePaddle={true} createSubscription={false} product='services' transactionAmount={props.authDetail.detail.renewal_fee} authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} triggerNotification={props.triggerNotification} />
            </Elements>
          </div>
        </Modal.Body>
      </Modal>
    );
  }else{
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Renew Your FlowPaper Services Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="content paymentForm">
            {/* <Row className="show-grid">
              <Col xs={12} md={8}>
                <code>.col-xs-12 .col-md-8</code>
              </Col>
              <Col xs={6} md={4}>
                <code>.col-xs-6 .col-md-4</code>
              </Col>
            </Row> */}

            <Elements>
              <InjectedCheckoutForm createSubscription={false} product='services' transactionAmount={props.authDetail.detail.renewal_fee} authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} triggerNotification={props.triggerNotification} />
            </Elements>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <p style={{fontSize:14,paddingLeft:15,paddingRight:15}}>Your credit card transaction is securely processed by <a href="https://stripe.com/" rel="nofollow" target="_new">Stripe</a>.</p>
          <Button bsStyle="default pull-right" fill type="submit"  onClick={props.onHide}>
                  Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function PurchaseAdditionalDomain(props) {
  if(props.authDetail.detail.usePaddle||USE_PADDLE_FOR_ADDITIONAL_DOMAIN){
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-700w">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Purchase Additional Domain
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="content paymentForm" style={{paddingTop:0}}>
            <Elements>
              <InjectedCheckoutForm usePaddle={true} createSubscription={false} product='domain' transactionAmount={50} authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} triggerNotification={props.triggerNotification} />
            </Elements>
          </div>
        </Modal.Body>
      </Modal>
    );
  }else{
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Purchase Additional Domain
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="content paymentForm">
            <Elements>
              <InjectedCheckoutForm createSubscription={false} product='domain' transactionAmount={50} authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} triggerNotification={props.triggerNotification} />
            </Elements>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <p style={{fontSize:14,paddingLeft:15,paddingRight:15}}>Your credit card transaction is securely processed by <a href="https://stripe.com/" rel="nofollow" target="_new">Stripe</a>.</p>
          <Button bsStyle="default pull-right" fill type="submit"  onClick={props.onHide}>
                  Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function SubAccountDialogue({ onCreateEdit, subAccount, runningOperation, ...props }){
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');

  React.useEffect(() => {
    setName(subAccount ? subAccount.name : '');
    setEmail(subAccount ? subAccount.email : '');
  }, [subAccount]);
  var dialogTitle = 'Create Team Account';
  var bttnLabel = 'Create Account';

  if(subAccount!=null){
    dialogTitle = 'Edit Team Account';
    bttnLabel = 'Save Changes';
  }

  return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-500w">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {dialogTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <FormGroup>
              <ControlLabel>Name</ControlLabel>
              <FormControl
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Email</ControlLabel>
              <FormControl
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>
          </form>
          <div show={!subAccount}>An email with account details will be dispatched to the email address specified when the account is created.</div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default pull-right" fill type="submit" onClick={props.onHide}>
            Cancel
          </Button>
          <ProgressButton style={{'min-width':'100px',marginRight:'10px'}} runningAsyncOperation={runningOperation} bsStyle="info" fill type="submit"  onClick={() => { onCreateEdit(name, email); }}>{bttnLabel}</ProgressButton>          
        </Modal.Footer>
      </Modal>
    );
}

function UpgradeToCreativeLicense(props) {
  if(props.authDetail.detail.usePaddle||USE_PADDLE_FOR_CREATIVE_UPGRADE){
    var dialogTitle = '';
    if(props.authDetail.detail.upgrade_fee && props.authDetail.txn_id.indexOf('_downgrade')==-1){
      dialogTitle = 'Upgrade Your Account to Creative License';
    }else{
      dialogTitle = 'Renew Your Creative Subscription';
    }

    if(props.transactionId != null){
      dialogTitle = 'Update your payment details';
    }

    var customStyles = { content : { 'max-width':'750px', width:'700px', height: '500px', top : '50%', left : '50%', right : 'auto', bottom : 'auto', marginRight : '-50%', transform : 'translate(-50%, -50%)' } };
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" dialogClassName="modal-700w">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {dialogTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="content paymentForm">
            <Elements>
              <InjectedCheckoutForm usePaddle={true} createSubscription={true} product='createsubscription' transactionAmount={props.authDetail.detail.upgrade_fee || props.authDetail.detail.creative_fee}  authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} transactionId={props.transactionId} triggerNotification={props.triggerNotification} />
            </Elements>
          </div>
        </Modal.Body>
      </Modal>
    );
  }else{
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.authDetail.detail.upgrade_fee && props.authDetail.txn_id.indexOf('_downgrade')==-1?<span>Upgrade Your Account to Creative License</span>:<span>Renew Your Creative Subscription</span>}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="content paymentForm">
            <Elements>
              <InjectedCheckoutForm createSubscription={true} product='createsubscription' transactionAmount={props.authDetail.detail.upgrade_fee || props.authDetail.detail.creative_fee}  authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} triggerNotification={props.triggerNotification} />
            </Elements>
          </div>
        </Modal.Body>
        <Modal.Footer>
        <p style={{fontSize:14,paddingLeft:15,paddingRight:15}}>Your credit card transaction is securely processed by <a href="https://stripe.com/" rel="nofollow" target="_new">Stripe</a>.</p>
          <Button bsStyle="default pull-right" fill type="submit"  onClick={props.onHide}>
                  Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


class UserProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
        NewName : this.props.authDetail.detail.name,
        NewEmail : this.props.authDetail.detail.email,
        NewEmailPrefs : this.props.authDetail.detail.emailprefs,
        NewCloudBotSettings : this.props.authDetail.detail.botprefs?this.props.authDetail.detail.botprefs:'Allow All Bots',
        NewCloudID : (this.props.authDetail.detail.cloudId?this.props.authDetail.detail.cloudId:this.props.authDetail.user),
        NewTaxID : (this.props.authDetail.detail.TaxID?this.props.authDetail.detail.TaxID:''),
        NewDomain : '',
        migrationTransactionId : null,
        registered_domains : this.props.authDetail.registered_domains,
        runningRegisterDomainOperation : false,
        runningUpdateProfileOperation : false,
        runningCancelSubscription : false,
        runningUpdatePaymentDetails : false,
        purchaseRenewalVisible : false,
        addEditSubAccountVisible : false,
        runningPurchaseDomain : false,
        runningCreateEditAccount : false,
        runningEnableDisableSubAccountId : null,
        purchaseUpgradeVisible : false,
        purchaseAdditionalDomainVisible : false,
        numSubAccountsAllowed : 0,
        numSubAccountsAdded : 0
    }

    if(this.props.authDetail.item.indexOf('Team')>-1){
      this.state.numSubAccountsAllowed = 8;
    }

    if(this.props.authDetail.item.indexOf('Pro')>-1){
      this.state.numSubAccountsAllowed = 20;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get("viapaddle") === "true") {
      
      setTimeout(function(){
        props.triggerNotification('success','tc','Transaction Completed. Please allow a few minutes for your account to refresh.');
        let url = new URL(window.location.href);url.searchParams.set("viapaddle", "false");
        window.history.replaceState(null, null, url.toString());
      },1500);
    }

    if(!this.props.authDetail.detail.cloudId){
        this.props.authDetail.detail.cloudId = this.props.authDetail.user
    }

    // add the list of sub accounts so we can show this in the account area
    if(this.props.authDetail.detail.sub_accounts){
      this.state.subAccounts = this.props.authDetail.detail.sub_accounts;

      for(var si=0;si<this.state.subAccounts.length;si++){
        if(this.state.subAccounts[si].active){
          this.state.numSubAccountsAdded++;
        }
      }
    }

    // set this flag to true if we want the user to go via Paddle
    if(this.props.authDetail){
      // this.props.authDetail.detail.usePaddle = true; 
      /**
       * What determines if we us Paddle or Stripe:
       * --------------------------------------------------------------------------------------------
       * We keep existing subscriptions in Stripe that are just renewing. 
       * 
       * The only scenario which remains in Stripe is a user with a user-entered and Stripe-validated TaxID. 
       * These users would remain in Stripe to avoid charging unessecary tax. 
       * 
       * Everyone else goes through the new dialogue. The dialogue will display any filled in company details
       * and allow the user to fill in the rest including TaxID before it goes to step 2, just as the download
       * page does. 
       * 
       * Make sure to update the paddle webhook so that we are saving the TaxID as well. 
       * 
       */
    }
  }

  handleUserInput (e) {
    const name = e.target.name;
    const value = e.target.value;
    const targetField = e.target;

    this.setState({[name]: value});
}

showPurchaseRenewal(){
  var _this = this;
  if((isFromEU() || (_this.props.authDetail.detail.BillingCountry && euCountries.includes(_this.props.authDetail.detail.BillingCountry))) && !_this.props.authDetail.detail.TaxID && !USE_PADDLE_FOR_FLOWPAPER_SERVICES){
    this.props.triggerNotification('error','tc','Please update your VAT/Tax ID before renewing your license.');    
  }else{
    this.setState({ purchaseRenewalVisible : true});
  }
}

hidePurchaseRenewal(){
  this.setState({ purchaseRenewalVisible : false});
}

showPurchaseUpgrade(){
  var _this = this;
  
  if((isFromEU() || (_this.props.authDetail.detail.BillingCountry && euCountries.includes(_this.props.authDetail.detail.BillingCountry))) && !_this.props.authDetail.detail.TaxID && !USE_PADDLE_FOR_CREATIVE_UPGRADE){
    this.props.triggerNotification('error','tc','Please update your VAT/Tax ID before renewing your license.');    
  }else{
    this.setState({ purchaseUpgradeVisible : true});
  }
}

showAddEditSubAccount(subAccount){
  this.setState({ runningAddEditSubAccount : true, addEditSubAccountVisible : true, currentSubAccount: subAccount });
}

enableOrDisableSubAccount(subAccount,enable){
  var _this = this;
  if(enable && this.state.numSubAccountsAdded >= this.state.numSubAccountsAllowed){
    this.props.triggerNotification('error','tc',"You have already added the maximum number of sub accounts allowed for your subscription. Please disable an existing sub account before enabling this one.");
    return;
  }
  if(enable || window.confirm("Are you sure you want to disable this team account? ("+subAccount.email+")")){
    var _this = this;
    this.setState({ runningEnableDisableSubAccountId: subAccount.txn_id });
    fetch("https://"+WEB_URL+"/account/api/creative-services",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        'body' : JSON.stringify({'action':'enable_disable_team_account','token':+_this.props.authDetail.token,'checksum':_this.props.authDetail.checksum,'txn_id':_this.props.authDetail.txn_id,'sub_txn_id':subAccount.txn_id, 'enable':enable})
    }).then(res => res.json())
    .then(
      (response) => {
        if(response.result == 'SUCCESS'){
          // triggering log in again so we get a new cookie
            fetch("https://"+WEB_URL+"/account/api/login",{
              'method' : 'POST',
              'headers' : { 'Content-Type' : 'application/json'},
              'body' : JSON.stringify({'token':_this.props.authDetail.token,'email':_this.props.authDetail.checksum,'detail':true}),
              'credentials': 'same-origin'
            }).then(res => res.json())
            .then(
                (result) => {
                    if(result.auth == 'AUTH_OK'){
                        if(result.detail.sub_accounts){
                          _this.setState({subAccounts : result.detail.sub_accounts});
                          
                          var numAccountsAdded = 0;
                          for(var si=0;si<_this.state.subAccounts.length;si++){
                            if(_this.state.subAccounts[si].active){
                              numAccountsAdded++;
                            }
                          }
                          _this.setState({ numSubAccountsAdded: numAccountsAdded });
                        }

                        _this.setState({ numSubAccountsAdded: numAccountsAdded, runningEnableDisableSubAccountId: null });
                    }else{
                      _this.props.setLoggedIn(false);    
                    }
                },
                (error) => {
                    _this.props.setLoggedIn(false);
                }
            )   
        }else{
            this.props.triggerNotification('error','tc',response.message);    
        }

        _this.setState({ currentSubAccount: null });
      },
      (error) => {
        _this.setState({ currentSubAccount: null, runningEnableDisableSubAccountId: null });
        this.props.triggerNotification('error','tc','Error creating/editing the team account. Please try again in a little while.');
      }
    )
  }
}

hidePurchaseUpgrade(){
  this.setState({ purchaseUpgradeVisible : false});
}

hidePurchaseAdditionalDomain(){
  this.setState({ purchaseAdditionalDomainVisible : false, runningPurchaseDomain : false});
}

initiateSubscriptionMigration(){
  this.setState({runningUpdatePaymentDetails : true});
  
  var _this = this;
  fetch("https://"+WEB_URL+"/account/api/creative-services",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      'body' : JSON.stringify({'action':'migratestripesubtopaddle','token':+this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email})
  }).then(res => res.json())
  .then(
    (response) => {
      if(response.result == 'SUCCESS'){
        // open the paddle payment widow using the transaction id
        this.setState({ migrationTransactionId : response.transactionId});
        this.setState({ purchaseUpgradeVisible : true});
        this.setState({ runningUpdatePaymentDetails : false });
      }else{
          this.props.triggerNotification('error','tc','Subscription system currently unavailable. Please contact support for assistance.');    
      }
    },
    (error) => {
      this.setState({ migrationTransactionId : null});
      this.props.triggerNotification('error','tc','Error processing the transaction.');
      this.setState({ runningUpdatePaymentDetails : false });
    }
  )
}

createEditTeamAccount(name, email){
  this.setState({runningCreateEditAccount : true});

  var _this = this;
  fetch("https://"+WEB_URL+"/account/api/creative-services",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      'body' : JSON.stringify(this.state.currentSubAccount
        ? {'action':'modify_team_account','token':+this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email,'name':name,'subAccountEmail':email,'txn_id':this.props.authDetail.txn_id,'sub_txn_id':this.state.currentSubAccount.txn_id}
        : {'action':'create_team_account','token':+this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email,'name':name,'subAccountEmail':email,'txn_id':this.props.authDetail.txn_id})
  }).then(res => res.json())
  .then(
    (response) => {
      if(response.result == 'SUCCESS'){
        this.setState({ runningCreateEditAccount : false });
        this.setState({ addEditSubAccountVisible : false });
        
        // triggering log in again so we get a new cookie
           fetch("https://"+WEB_URL+"/account/api/login",{
            'method' : 'POST',
            'headers' : { 'Content-Type' : 'application/json'},
            'body' : JSON.stringify({'token':this.props.authDetail.token,'email':this.props.authDetail.checksum,'detail':true}),
            'credentials': 'same-origin'
          }).then(res => res.json())
          .then(
              (result) => {
                  if(result.auth == 'AUTH_OK'){
                      if(result.detail.sub_accounts){
                        this.setState({subAccounts : result.detail.sub_accounts});
                      }

                      var numAccountsAdded = 0;
                      for(var si=0;si<_this.state.subAccounts.length;si++){
                        if(_this.state.subAccounts[si].active){
                          numAccountsAdded++;
                        }
                      }
                      _this.setState({ numSubAccountsAdded: numAccountsAdded });
                  }else{
                    _this.props.setLoggedIn(false);    
                  }
              },
              (error) => {
                  _this.props.setLoggedIn(false);
              }
          )   
      }else{
        this.setState({runningCreateEditAccount : false});
          this.props.triggerNotification('error','tc',response.message);    
      }
    },
    (error) => {
      this.props.triggerNotification('error','tc','Error creating/editing the team account. Please try again in a little while.');
    }
  )
}

createPaddlePortalSession(){ 
  var _this = this;
  this.setState({runningUpdatePaymentDetails : true});

  fetch("https://"+WEB_URL+"/account/api/creative-services",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      'body' : JSON.stringify({'action':'paddleportalsession','token':+this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email})
  }).then(res => res.json())
  .then(
    (response) => {
      if(response.result == 'SUCCESS'){
        // open the URL
        window.location.href = response.paddleSession.urls.general.overview;
      }else{
          this.props.triggerNotification('error','tc','Subscription system currently unavailable. Please contact support for assistance.');    
      }
    },
    (error) => {
      this.props.triggerNotification('error','tc','Error processing the transaction.');
      this.setState({runningStripePurchase : false});
    }
  )
}

cancelSubscription(){
  var _this = this;
  if(window.confirm("Are you sure you want to cancel your subscription?")){
    fetch("https://"+WEB_URL+"/account/api/creative-services",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'action=cancelsubscription&product=subscription&token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&email='+this.props.authDetail.detail.email
        'body' : JSON.stringify({'action':'cancelsubscription','product':'subscription','token':+this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email})
    }).then(res => res.json())
    .then(
      (response) => {
        if(response.result == 'SUCCESS'){
           // triggering log in again so we get a new cookie
           fetch("https://"+WEB_URL+"/account/api/login",{
            'method' : 'POST',
            'headers' : { 'Content-Type' : 'application/json'},
            //'body' : 'token='+this.props.authDetail.token+'&email='+this.props.authDetail.checksum+'&detail=true',
            'body' : JSON.stringify({'token':this.props.authDetail.token,'email':this.props.authDetail.checksum,'detail':true}),
            'credentials': 'same-origin'
          }).then(res => res.json())
          .then(
              (result) => {
                  if(result.auth == 'AUTH_OK'){
                      _this.props.setLoggedIn(result,_this.props.authEmail);
                      }else{
                      _this.props.setLoggedIn(false);    
                      }
              },
              (error) => {
                  _this.props.setLoggedIn(false);
              }
          )   
        }else{
            this.props.triggerNotification('error','tc','Subscription system currently unavailable. Please contact support for assistance.');    
        }

        this.props.triggerNotification('success','tc','Your subscription has been cancelled.');
      },
      (error) => {
        this.props.triggerNotification('error','tc','Error processing the transaction.');
        this.setState({runningStripePurchase : false});
      }
    )
  }
}

updatePaymentDetails(e){
  var _this = this;

  // if(_this.props.authDetail.detail.paddle_id){
    // this.setState({runningUpdatePaymentDetails : true});
    // _this.createPaddlePortalSession(); // change this to use a transaction instead- then use the portal piece in the invoices section. See https://developer.paddle.com/build/subscriptions/update-payment-details
  // }else{
    _this.initiateSubscriptionMigration();
  // }
  
  e.preventDefault();

}

handleUpdateUserDetails(e){
  this.setState({runningUpdateProfileOperation : true});
  var _this = this;

    fetch("https://"+WEB_URL+"/account/api/updateuser",{
            'method' : 'POST',
            'headers' : { 'Content-Type' : 'application/json'},
            //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&action=updatedetails&newemail='+this.state.NewEmail+'&newname='+this.state.NewName+'&newemailprefs='+this.state.NewEmailPrefs
            'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'updatedetails','newemail':this.state.NewEmail,'newname':this.state.NewName,'newemailprefs':this.state.NewEmailPrefs,'newcloudid':this.state.NewCloudID,'botprefs':this.state.NewCloudBotSettings,'newtaxid':this.state.NewTaxID})
          }).then(res => res.json())
            .then(
              (response) => {
                if(response.result == 'SUCCESS'){
                  // triggering log in again so we get a new cookie
                  fetch("https://"+WEB_URL+"/account/api/login",{
                    'method' : 'POST',
                    'headers' : { 'Content-Type' : 'application/json'},
                    //'body' : 'token='+this.props.authDetail.token+'&email='+this.props.authDetail.checksum+'&detail=true',
                    'body' : JSON.stringify({'token':this.props.authDetail.token,'email':this.props.authDetail.checksum,'detail':true}),
                    'credentials': 'same-origin'
                  }).then(res => res.json())
                  .then(
                      (result) => {
                          if(result.auth == 'AUTH_OK'){
                                  _this.props.setLoggedIn(result,_this.props.authEmail);

                                  _this.props.authDetail.detail.email = _this.state.NewEmail;
                                  _this.props.authDetail.detail.name = _this.state.NewName;
                                  _this.props.authDetail.detail.cloudId = (_this.props.authDetail.detail.cloudId?_this.props.authDetail.detail.cloudId:_this.props.authDetail.user);
                                  _this.props.authDetail.detail.emailprefs = _this.state.NewEmailPrefs;
                                  _this.props.authDetail.detail.botprefs = _this.state.NewCloudBotSettings;
                                  _this.props.authDetail.detail.TaxID = _this.state.NewTaxID;

                                  _this.setState({NewCloudID : _this.props.authDetail.detail.cloudId});

                                  _this.props.triggerNotification('success','tc',response.message);

                              }else{
                                  _this.props.setLoggedIn(false);    
                              }
                      },
                      (error) => {
                          _this.props.setLoggedIn(false);
                      });
                }else{
                  _this.props.authDetail.detail.cloudId = (_this.props.authDetail.detail.cloudId?_this.props.authDetail.detail.cloudId:_this.props.authDetail.user);
                  _this.setState({NewCloudID : _this.props.authDetail.detail.cloudId});

                  this.props.triggerNotification('error','tc',response.message);  
                }

                this.setState({runningUpdateProfileOperation : false});
              },
              (error) => {
                this.props.triggerNotification('error','tc','Error updating user details. Please try again in a little while.');
                this.setState({runningUpdateProfileOperation : false});
              }
            )

    e.preventDefault();
  }

  handlePurchaseDomain(e){
    this.setState({runningPurchaseDomain : true, purchaseAdditionalDomainVisible : true});
  }

  handleRegisterDomain(e){
    this.setState({runningRegisterDomainOperation : true});
    
    fetch("https://"+WEB_URL+"/account/api/updateuser",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&action=registerdomain&newdomain='+this.state.NewDomain
      'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'registerdomain','newdomain':this.state.NewDomain})
    }).then(res => res.json())
      .then(
        (response) => {
          if(response.result == 'SUCCESS'){
            this.setState({registered_domains: response.registered_domains});
            this.props.triggerNotification('success','tc',response.message);
          }else{
            
          }

          this.setState({runningRegisterDomainOperation : false});
        },
        (error) => {
          this.props.triggerNotification('error','tc','Error registering the domain. Please try again in a little while.');
          this.setState({runningRegisterDomainOperation : false});
        }
      )

    e.preventDefault();
  }

  handleUpgradeToCreative(e){

  }

  datediff(first, second) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round((second-first)/(1000*60*60*24));
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
            <Row>
              <Col md={12}>
                <Card
                  title="Edit Profile"
                  content={
                    <form>
                      <FormInputs
                        ncols={["col-md-6", "col-md-6"]}
                        properties={[
                          {
                            label: "Name",
                            name: "NewName",
                            type: "text",
                            bsClass: "form-control",
                            placeholder: "Name",
                            defaultValue: this.props.authDetail.detail.name
                          },
                          {
                            label: "Cloud ID",
                            name: "NewCloudID",
                            type: "text",
                            bsClass: "form-control",
                            placeholder: "CloudID",
                            tooltip: "This ID is the start of the URL for your cloud hosted publications. Changing this ID will allow you to customize your URL (yourID.flowpaper.com). Updating this ID will not break publications hosted under your default ID ("+this.props.authDetail.user+")",
                            value: this.state.NewCloudID
                          },
                          {
                            label: "Email",
                            name: "NewEmail",
                            type: "text",
                            bsClass: "form-control",
                            placeholder: "Email",
                            defaultValue: this.props.authDetail.detail.email
                          }
                        ]}
                        onChange={(event) => this.handleUserInput(event)} 
                      />

                      <FormInputs
                        ncols={["col-md-6","col-md-6"]}
                        properties={[
                          {
                            label: "Email",
                            name: "NewEmail",
                            type: "text",
                            bsClass: "form-control",
                            placeholder: "Email",
                            defaultValue: this.props.authDetail.detail.email
                          },
                          {
                            label: "Email Preferences",
                            name: "NewEmailPrefs",
                            componentClass: "select",
                            options:[{value:"All"},{value:"Account"},{value:"None"}],
                            selected: this.state.NewEmailPrefs,
                            value: this.state.NewEmailPrefs,
                            bsClass: "form-control",
                            defaultValue: this.props.authDetail.detail.email
                          }
                        ]}
                        onChange={(event) => this.handleUserInput(event)} 
                      />                    

                      <FormInputs
                        ncols={["col-md-6","col-md-6"]}
                        properties={[
                          {
                            label: "Bot Permission Settings",
                            name: "NewCloudBotSettings",
                            componentClass: "select",
                            options:[{value:"Allow All Bots"},{value:"Only Allow Search Bots"},{value:"Only Allow AI Crawler Bots"},{value:"Disallow All Bots"}],
                            selected: this.state.NewCloudBotSettings,
                            value: this.state.NewCloudBotSettings,
                            bsClass: "form-control",
                            defaultValue: "Allow All Bots"
                          },
                          {
                            label: "VAT / Tax ID",
                            name: "NewTaxID",
                            type: "text",
                            bsClass: "form-control",
                            placeholder: "TaxID",
                            tooltip: "This is your VAT/Tax ID. If you are a business in the EU, you are required to provide this ID.",
                            value: this.state.NewTaxID
                          }
                        ]}
                        onChange={(event) => this.handleUserInput(event)} 
                      />    
                      
                      <ProgressButton runningAsyncOperation={this.state.runningUpdateProfileOperation} bsStyle="info" fill type="submit" onClick={(e) => {this.handleUpdateUserDetails(e);}}>
                        Update Profile
                      </ProgressButton>

                      <Button bsStyle="warning pull-right" fill type="submit" onClick={(e) => this.props.history.push('/home/setpassword')}>
                        Change Password
                      </Button>
                      <div className="clearfix" />
                    </form>
                  }
                />
                </Col>
              </Row>

              {(this.state.numSubAccountsAllowed > 0)?
              <Row>
              <Col md={12}>
                <Card
                  title={`Manage Team Accounts (${this.state.numSubAccountsAdded}/${this.state.numSubAccountsAllowed})`}
                  content={<div>
                    {(this.state.subAccounts.length > 0)?
                      <Table striped hover>
                      <thead>
                        <tr>
                          <th>Account</th>
                          <th>Date Created</th>
                          <th className="pull-right">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                          {this.state.subAccounts.map((subAccount, index) => {
                        
                          return (
                              <tr key={`${subAccount.txn_id}`}>
                                  <td>{subAccount.email} {(!subAccount.active?<span style={{fontStyle: 'italic'}}>(Disabled)</span>:null)}</td>
                                  <td>{new Date(subAccount.reg_date).toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</td>

                                  {/* <td><button type="submit" onClick={(e) => this.showAddEditSubAccount(subAccount, e)} className="pull-right btn btn-sm btn-fill" style={{marginRight:10}}>Edit</button></td> */}
                                  <td>
                                    {(subAccount.active?
                                    <ProgressButton runningAsyncOperation={this.state.runningEnableDisableSubAccountId === subAccount.txn_id} type="submit" onClick={(e) => this.enableOrDisableSubAccount(subAccount, false, e)} bsStyle="warning btn-sm pull-right" fill style={{marginRight:10,minWidth:70}}>Disable</ProgressButton>
                                    :<ProgressButton runningAsyncOperation={this.state.runningEnableDisableSubAccountId === subAccount.txn_id} type="submit" onClick={(e) => this.enableOrDisableSubAccount(subAccount, true, e)} bsStyle="info btn-sm pull-right" fill style={{marginRight:10,minWidth:70}}>Enable</ProgressButton>)}
                                  </td>
                              </tr>
                          );
                      })}
                      </tbody>
                    </Table>
                    :''}

                    
                    {(this.state.numSubAccountsAllowed > this.state.numSubAccountsAdded)?
                    <Row>
                    <Col md={3}>
                      <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningAddEditSubAccount} bsStyle="info" fill type="submit" onClick={(e) => {this.showAddEditSubAccount(null,e);}}>
                          Add Account
                      </ProgressButton>
                    </Col>
                    <SubAccountDialogue subAccount={this.state.currentSubAccount} runningOperation={this.state.runningCreateEditAccount} show={this.state.addEditSubAccountVisible} onShow={() => this.setState({ runningAddEditSubAccount: false })} onHide={() => this.setState({ addEditSubAccountVisible: false, runningAddEditSubAccount: false, currentSubAccount: null })} onCreateEdit={(name, email) => this.createEditTeamAccount(name, email)} />
                    </Row>
                    :<SubAccountDialogue subAccount={this.state.currentSubAccount} runningOperation={this.state.runningCreateEditAccount} show={this.state.addEditSubAccountVisible} onShow={() => this.setState({ runningAddEditSubAccount: false })} onHide={() => this.setState({ addEditSubAccountVisible: false, runningAddEditSubAccount: false, currentSubAccount: null })} onCreateEdit={(name, email) => this.createEditTeamAccount(name, email)} />}
                  </div>
                  }
                />
                </Col>
              </Row>:''}

              {(this.props.authDetail.detail.haszine || this.props.authDetail.detail.hasclassic || this.props.authDetail.detail.hasannotations) && !this.props.authDetail.detail.hascreative?
                <Row>
                  <Col md={12}>
                    <Card
                    title="Account License Keys"
                    content={
                      <form style={{minHeight:100,paddingBottom:40}}>
                          {this.state.registered_domains.map((domain, index) => {
                            return (<div key={domain.key} style={{paddingBottom:'20px'}}><b>domain: </b>{domain.domain}<br/><span><b>key: </b>{domain.key}</span></div>); 
                          })}

                          {this.state.registered_domains.length < this.props.authDetail.allowed_domains ? 
                          
                          <FormInputs
                            ncols={["col-md-12"]}
                            properties={[
                              {
                                label: "Register Domain",
                                name: "NewDomain",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Domain Name",
                                defaultValue: ''
                              }
                            ]}
                            onChange={(event) => this.handleUserInput(event)} 
                          />
                          :''}

                        {this.state.registered_domains.length < this.props.authDetail.allowed_domains ? 
                          <ProgressButton runningAsyncOperation={this.state.runningRegisterDomainOperation} bsStyle="info" fill type="submit" onClick={(e) => {this.handleRegisterDomain(e);}}>
                            Register Domain
                          </ProgressButton>:''}

                          <ProgressButton runningAsyncOperation={this.state.runningPurchaseDomain} bsStyle="info pull-right" fill type="submit" onClick={(e) => {this.handlePurchaseDomain(e);}}>
                            Purchase Additional License (+1 domain)
                          </ProgressButton>
                        
                          <PurchaseAdditionalDomain authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} show={this.state.purchaseAdditionalDomainVisible} onHide={() => this.hidePurchaseAdditionalDomain(false)} />
                      </form>
                    }
                  />
                  </Col>
                </Row>
                :''}

                {!USE_PADDLE_FOR_FLOWPAPER_SERVICES && this.props.authDetail.detail.cloudId? 
                <Row>
                  <Col md={12}>
                    <Card
                    title="Update Credit Card"
                    content={
                     <div>
                       {this.props.authDetail.detail.paymentMethods && this.props.authDetail.detail.paymentMethods.length?
                       <div>
                        <Row>
                          <Col md={6} style={{minWidth:'475px'}}>
                          <FormGroup>
                            <ControlLabel>Current Card</ControlLabel>
                            <p style={{color:'#565656',fontSize:'14px'}}>XXXX-XXXX-XXXX-{this.props.authDetail.detail.paymentMethods[0].last4}</p>
                          </FormGroup>
                          </Col>
                          <Col md={2}>
                          <FormGroup>
                            <ControlLabel>Exp Date</ControlLabel>
                            <p style={{color:'#565656',fontSize:'14px'}}>{this.props.authDetail.detail.paymentMethods[0].exp_month}/{this.props.authDetail.detail.paymentMethods[0].exp_year}</p>
                          </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Elements>
                              <InjectedCreditCardDetails setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} />
                            </Elements>
                          </Col>
                        </Row>
                      </div>
                       :
                       <div>
                        <Row>
                          <Col md={6} style={{minWidth:'475px'}}>
                          <FormGroup>
                            <ControlLabel>Current Card</ControlLabel>
                            <p style={{color:'#565656',fontSize:'14px'}}></p>
                          </FormGroup>
                          </Col>
                          <Col md={2}>
                          <FormGroup>
                            <ControlLabel>Exp Date</ControlLabel>
                            <p style={{color:'#565656',fontSize:'14px'}}></p>
                          </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Elements>
                              <InjectedCreditCardDetails setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} />
                            </Elements>
                          </Col>
                        </Row>
                      </div>}
                     </div>
                    }/>
                    </Col>
                </Row>:''}
            </Col>
            <Col md={4}>
            <Row>
              <Col md={12}>
                <Card
                    title={this.props.authDetail.detail.hascreative?'Your Subcription':'Your Account'}
                    content={
                      <div>
                          <b style={{fontSize:'0.95em',textTransform:'Uppercase'}}>{this.props.authDetail.item}</b>
                          <br/>
                          {this.props.authDetail.detail.hascreative?<span style={{fontSize:'0.95em',textTransform:'Uppercase'}}><b>Annual Fee:</b> ${Number(this.props.authDetail.detail.creative_fee).toFixed(2)}</span>:''}
                          {this.props.authDetail.detail.haszine && !this.props.authDetail.detail.hascreative?<h4 style={{fontSize:17,marginBottom:-20}}>Your Services Account</h4>:''}
                          <br/>
                          <span style={{fontSize:'0.95em',textTransform:'Uppercase'}}><b>Valid until:</b> {new Date(this.props.authDetail.detail.reg_date_plus1y).toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span><br/>
                          {!(this.props.authDetail.txn_id.indexOf('_downgrade')>-1) && this.datediff(new Date(),new Date(this.props.authDetail.detail.reg_date_plus1y))<-365/2?<span><br/><br/><b style={{color:'#e74c3c'}}>YOUR CLOUD STORAGE HAS EXPIRED.</b><br/>Renewing your services account will restore any archived publications that were removed from FlowPaper Cloud when your account expired.</span>:""}

                          {/* Paddle/Stripe creative subscription management. Paddle goes to Portal and Stripe goes to moving customers from Stripe to Paddle */}
                          {this.props.authDetail.detail.paddle_id && this.props.authDetail.detail.hascreative?
                            <div>
                              <br/><br/>
                              <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningUpdatePaymentDetails} bsStyle="info" fill type="submit" onClick={(e) => {this.createPaddlePortalSession(e);}}>Manage Subscription</ProgressButton>
                            </div>
                            : 
                            <div>
                              {this.props.authDetail.detail.hascreative && (this.props.authDetail.detail.isactive && new Date(this.props.authDetail.detail.reg_date_plus1y) >= new Date())?
                              <div>
                              <br/>
                              <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningCancelSubscription} bsStyle="warning" fill type="submit" onClick={(e) => {this.cancelSubscription(e);}}>
                              Cancel Subscription
                              </ProgressButton>
                              <br/><br/>
                              {USE_PADDLE_FOR_CREATIVE_UPGRADE?
                              <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningUpdatePaymentDetails} bsStyle="info" fill type="submit" onClick={(e) => {this.updatePaymentDetails(e);}}>
                              Update Payment Details
                              </ProgressButton>:''}
                              <UpgradeToCreativeLicense authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} transactionId={this.state.migrationTransactionId} show={this.state.purchaseUpgradeVisible} onHide={() => this.hidePurchaseUpgrade(false)} />
                            </div>
                            :''} 
                            {this.props.authDetail.detail.hascreative && (!this.props.authDetail.detail.isactive || new Date(this.props.authDetail.detail.reg_date_plus1y) < new Date())?<p>
                            {!USE_PADDLE_FOR_CREATIVE_UPGRADE?<span style={{color:'#ff0000'}}><br/><br/>Your subscription will not automatically renew.</span>:''}
                              <br/><br/>
                              <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningPurchaseUpgrade} bsStyle="info" fill type="submit" onClick={(e) => {this.showPurchaseUpgrade(e);}}>
                                Renew FlowPaper Subscription
                              </ProgressButton>
                              <br/><br/>
                              {USE_PADDLE_FOR_CREATIVE_UPGRADE && new Date(this.props.authDetail.detail.reg_date_plus1y) >= new Date()?
                              <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningUpdatePaymentDetails} bsStyle="info" fill type="submit" onClick={(e) => {this.updatePaymentDetails(e);}}>
                              Update Payment Details
                              </ProgressButton>:''}
                              <UpgradeToCreativeLicense authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} transactionId={this.state.migrationTransactionId} show={this.state.purchaseUpgradeVisible} onHide={() => this.hidePurchaseUpgrade(false)} />
                            </p>:''}
                            </div>
                          }

                          {this.props.authDetail.detail.haszine && !this.props.authDetail.detail.hascreative && !(this.props.authDetail.txn_id.indexOf('_downgrade')>-1)?<p style={{fontSize:'0.85em', marginTop:20}}>A FlowPaper services account gives you access to upgrades (new releases) and cloud hosting. FlowPaper Zine and Classic licenses include access to FlowPaper services for 12 months from date of purchase. Active Creative and Team subscription accounts can always access these services.

                          You can purchase an additional year of access to FlowPaper services at a discounted price of the 50% of base license fee if you want to renew access to these services.
                          <br/><br/>
                          <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningRenewServicesAccount} bsStyle="info" fill type="submit" onClick={(e) => {this.showPurchaseRenewal(e);}}>
                          Renew FlowPaper Services
                          </ProgressButton>
                  
                          <RenewFlowPaperServicesModal authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} show={this.state.purchaseRenewalVisible} onHide={() => this.hidePurchaseRenewal(false)} />
                  
                          </p>

                          :""}
                      </div>
                    }
                  />
                </Col>
              </Row>

                {this.props.authDetail.detail.haszine && this.props.authDetail.txn_id.indexOf('_downgrade')==-1 && !this.props.authDetail.detail.hascreative && this.props.authDetail.detail.show_upgrade_creative?
                <Row>
                  <Col md={12}>
                    <Card
                    title="Account Upgrades"
                    content={
                      <p style={{fontSize:'0.85em'}}>Upgrading to a Creative License annual subscription (${Number(this.props.authDetail.detail.upgrade_fee).toFixed(2)}/year) will give you access to more optimization settings and more templates as well as the ability to publish to unlimited domains. <a href="/download/" target="_new">Read more</a>
                        <br/><br/>
                        <ProgressButton style={{'min-width':'100%'}} runningAsyncOperation={this.state.runningPurchaseUpgrade} bsStyle="info" fill type="submit" onClick={(e) => {this.showPurchaseUpgrade(e);}}>
                        Upgrade to Creative License
                        </ProgressButton>

                        {/* <Button bsStyle="info" fill type="submit" onClick={(e) => {this.handleUpgradeToCreative(e);}}>
                            Upgrade to Creative License */}

                            <UpgradeToCreativeLicense authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} show={this.state.purchaseUpgradeVisible} onHide={() => this.hidePurchaseUpgrade(false)} />
                        
                      </p>
                    }
                    />
                    </Col>
                  </Row>
                  :''}

                {this.props.authDetail.detail.haszine && this.props.authDetail.txn_id.indexOf('_downgrade')>-1 && !this.props.authDetail.detail.hascreative && this.props.authDetail.detail.show_upgrade_creative?
                <Row>
                  <Col md={12}>
                    <Card
                    title="Renew FlowPaper Subscription"
                    content={
                      <p style={{fontSize:'0.85em'}}>
                        <span><b style={{color:'#e74c3c'}}>YOUR ACCOUNT WAS DOWNGRADED TO FLOWPAPER ZINE.</b><br/><br/>Renewing your creative license (${Number(this.props.authDetail.detail.upgrade_fee).toFixed(2)}) will restore any archived publications that were removed from FlowPaper Cloud when your account was downgraded.</span>
                        <br/><br/>
                        <ProgressButton runningAsyncOperation={this.state.runningPurchaseUpgrade} bsStyle="info" fill type="submit" onClick={(e) => {this.showPurchaseUpgrade(e);}}>
                        Renew FlowPaper Subscription
                        </ProgressButton>

                        {/* <Button bsStyle="info" fill type="submit" onClick={(e) => {this.handleUpgradeToCreative(e);}}>
                            Upgrade to Creative License */}

                            <UpgradeToCreativeLicense authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} show={this.state.purchaseUpgradeVisible} onHide={() => this.hidePurchaseUpgrade(false)} />
                        
                      </p>
                    }
                    />
                    </Col>
                  </Row>
                  :''}

            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserProfile;



const TIMEZONE = {
  ANDORRA: {
      ANDORRA: 'Europe/Andorra'
  },
  AUSTRIA: {
      VIENNA: 'Europe/Vienna'
  },
  BELGIUM: {
      BRUSSELS: 'Europe/Brussels'
  },
  BULGARIA: {
      SOFIA: 'Europe/Sofia'
  },
  CROATIA: {
      ZAGREB: 'Europe/Zagreb'
  },
  CYPRUS: {
      NICOSIA_EUROPE: 'Europe/Nicosia',
      NICOSIA_ASIA: 'Asia/Nicosia',
      FAMAGUSTA: 'Asia/Famagusta'
  },
  CZECHIA: {
      PRAGUE: 'Europe/Prague'
  },
  DENMARK: {
      COPENHAGEN: 'Europe/Copenhagen',
      FAROE: 'Atlantic/Faroe'
  },
  ESTONIA: {
      TALLINN: 'Europe/Tallinn'
  },
  FINLAND: {
      HELSINKI: 'Europe/Helsinki',
      MARIEHAMN: 'Europe/Mariehamn'
  },
  FRANCE: {
      PARIS: 'Europe/Paris',
      CAYENNE: 'America/Cayenne',
      GUADELOUPE: 'America/Guadeloupe',
      MARIGOT: 'America/Marigot',
      MARTINIQUE: 'America/Martinique',
      MAYOTTE: 'Indian/Mayotte',
      REUNION: 'Indian/Reunion'
  },
  GERMANY: {
      BERLIN: 'Europe/Berlin',
      BUSINGEN: 'Europe/Busingen'
  },
  GREECE: {
      ATHENS: 'Europe/Athens'
  },
  HUNGARY: {
      BUDAPEST: 'Europe/Budapest'
  },
  ICELAND: {
      REYKJAVIK: 'Atlantic/Reykjavik'
  },
  IRELAND: {
      DUBLIN: 'Europe/Dublin'
  },
  ITALY: {
      ROME: 'Europe/Rome'
  },
  LATVIA: {
      RIGA: 'Europe/Riga'
  },
  LIECHTENSTEIN: {
      VADUZ: 'Europe/Vaduz'
  },
  LITHUANIA: {
      VILNIUS: 'Europe/Vilnius'
  },
  LUXEMBOURG: {
      LUXEMBOURG: 'Europe/Luxembourg'
  },
  MALTA: {
      MALTA: 'Europe/Malta'
  },
  MONACO: {
      MONACO: 'Europe/Monaco'
  },
  NETHERLANDS: {
      AMSTERDAM: 'Europe/Amsterdam',
      ARUBA: 'America/Aruba',
      CURACAO: 'America/Curacao',
      KRALENDIJK: 'America/Kralendijk',
      LOWER_PRINCES: 'America/Lower_Princes'
  },
  NORWAY: {
      OSLO: 'Europe/Oslo',
      JAN_MAYEN: 'Atlantic/Jan_Mayen',
      LONGYEARBYEN: 'Arctic/Longyearbyen'
  },
  POLAND: {
      WARSAW: 'Europe/Warsaw'
  },
  PORTUGAL: {
      LISBON: 'Europe/Lisbon',
      AZORES: 'Atlantic/Azores',
      MADEIRA: 'Atlantic/Madeira'
  },
  ROMANIA: {
      BUCHAREST: 'Europe/Bucharest'
  },
  SAN_MARINO: {
      SAN_MARINO: 'Europe/San_Marino'
  },
  SLOVAKIA: {
      BRATISLAVA: 'Europe/Bratislava'
  },
  SLOVENIA: {
      LJUBLJANA: 'Europe/Ljubljana'
  },
  SPAIN: {
      MADRID: 'Europe/Madrid',
      CANARY: 'Atlantic/Canary',
      CEUTA: 'Africa/Ceuta'
  },
  SWEDEN: {
      STOCKHOLM: 'Europe/Stockholm'
  },
  SWITZERLAND: {
      ZURICH: 'Europe/Zurich'
  },
  VATICAN: {
      VATICAN: 'Europe/Vatican'
  }
};
const EU_TIMEZONE = [
  TIMEZONE.AUSTRIA.VIENNA,
  TIMEZONE.BELGIUM.BRUSSELS,
  TIMEZONE.BULGARIA.SOFIA,
  TIMEZONE.CROATIA.ZAGREB,
  TIMEZONE.CYPRUS.NICOSIA_EUROPE,
  TIMEZONE.CYPRUS.NICOSIA_ASIA,
  TIMEZONE.CYPRUS.FAMAGUSTA,
  TIMEZONE.CZECHIA.PRAGUE,
  TIMEZONE.DENMARK.COPENHAGEN,
  TIMEZONE.ESTONIA.TALLINN,
  TIMEZONE.FINLAND.HELSINKI,
  TIMEZONE.FINLAND.MARIEHAMN,
  TIMEZONE.FRANCE.PARIS,
  TIMEZONE.GERMANY.BERLIN,
  TIMEZONE.GREECE.ATHENS,
  TIMEZONE.HUNGARY.BUDAPEST,
  TIMEZONE.IRELAND.DUBLIN,
  TIMEZONE.ITALY.ROME,
  TIMEZONE.LATVIA.RIGA,
  TIMEZONE.LITHUANIA.VILNIUS,
  TIMEZONE.LUXEMBOURG.LUXEMBOURG,
  TIMEZONE.MALTA.MALTA,
  TIMEZONE.NETHERLANDS.AMSTERDAM,
  TIMEZONE.POLAND.WARSAW,
  TIMEZONE.PORTUGAL.LISBON,
  TIMEZONE.ROMANIA.BUCHAREST,
  TIMEZONE.SLOVAKIA.BRATISLAVA,
  TIMEZONE.SLOVENIA.LJUBLJANA,
  TIMEZONE.SPAIN.MADRID,
  TIMEZONE.SWEDEN.STOCKHOLM,
  TIMEZONE.FRANCE.CAYENNE,
  TIMEZONE.FRANCE.GUADELOUPE,
  TIMEZONE.FRANCE.MARIGOT,
  TIMEZONE.FRANCE.MARTINIQUE,
  TIMEZONE.FRANCE.MAYOTTE,
  TIMEZONE.FRANCE.REUNION,
  TIMEZONE.PORTUGAL.AZORES,
  TIMEZONE.PORTUGAL.MADEIRA,
  TIMEZONE.SPAIN.CANARY
];
const EEA_EFTA_TIMEZONE = [
  TIMEZONE.ICELAND.REYKJAVIK,
  TIMEZONE.LIECHTENSTEIN.VADUZ,
  TIMEZONE.NORWAY.OSLO,
  TIMEZONE.NORWAY.JAN_MAYEN
];
const EEA_TIMEZONE = [
  ...EU_TIMEZONE,
  ...EEA_EFTA_TIMEZONE
];
const EFTA_TIMEZONE = [
  TIMEZONE.SWITZERLAND.ZURICH,
  ...EEA_EFTA_TIMEZONE
];
const SCHENGEN_TIMEZONE = [
  TIMEZONE.AUSTRIA.VIENNA,
  TIMEZONE.BELGIUM.BRUSSELS,
  TIMEZONE.BULGARIA.SOFIA,
  TIMEZONE.CROATIA.ZAGREB,
  TIMEZONE.CZECHIA.PRAGUE,
  TIMEZONE.DENMARK.COPENHAGEN,
  TIMEZONE.ESTONIA.TALLINN,
  TIMEZONE.FINLAND.HELSINKI,
  TIMEZONE.FINLAND.MARIEHAMN,
  TIMEZONE.FRANCE.PARIS,
  TIMEZONE.GERMANY.BERLIN,
  TIMEZONE.GREECE.ATHENS,
  TIMEZONE.HUNGARY.BUDAPEST,
  TIMEZONE.ITALY.ROME,
  TIMEZONE.LATVIA.RIGA,
  TIMEZONE.LITHUANIA.VILNIUS,
  TIMEZONE.LUXEMBOURG.LUXEMBOURG,
  TIMEZONE.MALTA.MALTA,
  TIMEZONE.NETHERLANDS.AMSTERDAM,
  TIMEZONE.POLAND.WARSAW,
  TIMEZONE.PORTUGAL.LISBON,
  TIMEZONE.PORTUGAL.AZORES,
  TIMEZONE.PORTUGAL.MADEIRA,
  TIMEZONE.ROMANIA.BUCHAREST,
  TIMEZONE.SLOVAKIA.BRATISLAVA,
  TIMEZONE.SLOVENIA.LJUBLJANA,
  TIMEZONE.SPAIN.MADRID,
  TIMEZONE.SPAIN.CANARY,
  TIMEZONE.SWEDEN.STOCKHOLM,
  TIMEZONE.ANDORRA.ANDORRA,
  TIMEZONE.GERMANY.BUSINGEN,
  TIMEZONE.ICELAND.REYKJAVIK,
  TIMEZONE.LIECHTENSTEIN.VADUZ,
  TIMEZONE.MONACO.MONACO,
  TIMEZONE.NORWAY.OSLO,
  TIMEZONE.SAN_MARINO.SAN_MARINO,
  TIMEZONE.SPAIN.CEUTA,
  TIMEZONE.SWITZERLAND.ZURICH,
  TIMEZONE.VATICAN.VATICAN
];
const isTimezoneIn = (tz) => { var _a; return typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat) && tz.includes(Intl.DateTimeFormat().resolvedOptions().timeZone); };
const isFromEU = () => isTimezoneIn(EU_TIMEZONE);
const isFromEEA = () => isTimezoneIn(EEA_TIMEZONE);
const isFromEFTA = () => isTimezoneIn(EFTA_TIMEZONE);
const isFromSchengen = () => isTimezoneIn(SCHENGEN_TIMEZONE);
const euCountries = [
    "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark",
    "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy",
    "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal",
    "Romania", "Slovakia", "Slovenia", "Spain", "Sweden", "United Kingdom"
];